import { render, staticRenderFns } from "./pdproduct4.vue?vue&type=template&id=2bd79334&scoped=true"
import script from "./pdproduct4.vue?vue&type=script&lang=js"
export * from "./pdproduct4.vue?vue&type=script&lang=js"
import style0 from "./pdproduct4.vue?vue&type=style&index=0&id=2bd79334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd79334",
  null
  
)

export default component.exports